import { put, call, fork, take } from 'redux-saga/effects';
import { acceptError } from 'common/_redux';
import { REQUEST } from 'redux-config/reduxHelpers';

import * as api from '../api';
import * as ActionTypes from './actions';

export function* getLiquidCashbackIframeUrlSaga() {
  try {
    const { data } = yield call(api.getLiquidCashbackIframeUrl);
    yield put(ActionTypes.getLiquidCashbackIframeUrl.success(data));
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.getLiquidCashbackIframeUrl.failure(e));
  }
}

export function* getLiquidCashbackIframeUrlWatcherSaga() {
  while (true) {
    yield take(ActionTypes.GET_LIQUID_CASHBACK_IFRAME_URL[REQUEST]);
    yield call(getLiquidCashbackIframeUrlSaga);
  }
}

export default [fork(getLiquidCashbackIframeUrlWatcherSaga)];
